<div *ngIf="opexPercentage"
     class="save-confirm-pop-up"
     [ngStyle]="{'top': positionTop + 'px',
                 'right': positionRight + 'px',
                 'bottom': positionBottom + 'px',
                 'left': positionLeft + 'px'}"

>
  <p>
    <span *ngIf="isProjectInput()">
      {{'PROJECT.INITIAL.ESTIMATE_TOOLTIP' | anessaTranslation: trigger}}.
    </span>
    <br *ngIf="isProjectInput()">
    {{'PROJECT.FINANCIAL_OPEX.ESTIM_CONFIRM' | anessaTranslation: trigger}}
  </p>
  <form #opexPercentageForm="ngForm">
    <div class="whiteBox">
      <!-- header -->
      <div class="opex-perc-header-container">
        <h3 class="no-default-margin anessa-dark-blue" anessaTranslation="PROJECT.FINANCIAL_OPEX.OPEX_PERCENT"></h3>
        <i class="material-icons"
          [matTooltip]="('PROJECT.FINANCIAL_OPEX.TOOLTIP_OPEX_PERCENT' | anessaTranslation: trigger)"
        >help</i>
      </div>
      <!-- input (unit value) -->
      <div class="wide">
        <app-unit-value
          [setGreaterThanValue]="2"
          [setLessThanValue]="20"
          [units]="'Perc_Capex'"
          [(ngModel)]="opexPercentage"
          [disableClear]="true"
          [coloredInputs]="true"
          [defaultInputs]="defaultInputs"
          name="opex-percentage"
        ></app-unit-value>
      </div>
    </div>
  </form>
  <!-- save/cancel buttons -->
  <div class="compact-button-group">
    <button id="opex-estimation-confirm-yes_button"
            class="btn-compact btn-green"
            mat-button
            type="button"
            [disabled]="opexPercentageForm.invalid || !this.opexPercentage.value"
            (click)="confirmClick()"
            anessaTranslation="PROJECT.COMMON.YES"
    ></button>
    <button id="opex-estimation-confirm-no_button"
            class="btn-compact btn-red"
            mat-button
            type="button"
            (click)="rejectClick()"
            anessaTranslation="PROJECT.COMMON.NO"
    ></button>
  </div>
</div>
